import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { MessageCircle, Loader } from "lucide-react";

const PuccCertificate = () => {
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // prevents smooth scroll
    });
  }, []);
  const handleWhatsAppRedirect = async () => {
    try {
      setIsLoading(true);

      // Show loading toast
      const toastId = toast.loading(
        "🔄 Redirecting you to WhatsApp. Please wait...",
        {
          position: "top-right",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
        },
      );

      // Wait for 2 seconds to let user see the message
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Dismiss the loading toast
      toast.dismiss(toastId);

      // Show success message
      toast.success("Opening WhatsApp...", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Redirect to WhatsApp
      // Replace with your actual business WhatsApp number (e.g., +919999999999)
      const whatsappPhone = "+919124578108";
      const whatsappUrl = `https://wa.me/${whatsappPhone.replace(/\D/g, "")}?text=Hello,%20I%20need%20PUCC%20Certificate%20assistance.`;

      // Open WhatsApp in new tab after a small delay
      setTimeout(() => {
        window.open(whatsappUrl, "_blank");
      }, 500);
    } catch (error) {
      toast.error("Failed to redirect. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
      console.error("WhatsApp redirect error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      {/* Header Section */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          PUCC Certificate
        </h2>
        <p className="text-gray-600 text-lg">
          Get your Pollution Under Control certificate online through WhatsApp
        </p>
      </div>

      {/* Info Card */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-6 mb-8">
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <div className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 text-sm font-bold mt-1">
              ✓
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">
                Quick & Easy Process
              </h3>
              <p className="text-gray-600 text-sm mt-1">
                Complete your PUCC certificate application in minutes via
                WhatsApp
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 text-sm font-bold mt-1">
              ✓
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Expert Support</h3>
              <p className="text-gray-600 text-sm mt-1">
                Our dedicated team will guide you through every step
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 text-sm font-bold mt-1">
              ✓
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Valid Certificate</h3>
              <p className="text-gray-600 text-sm mt-1">
                Receive an official and legally valid PUCC certificate
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Button */}
      <div className="flex flex-col gap-4">
        <button
          onClick={handleWhatsAppRedirect}
          disabled={isLoading}
          className={`w-full py-4 px-6 rounded-lg font-semibold text-lg flex items-center justify-center gap-3 transition-all duration-300 ${
            isLoading
              ? "bg-gray-300 text-gray-600 cursor-not-allowed"
              : "bg-gradient-to-r from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700 shadow-lg hover:shadow-xl active:scale-95"
          }`}
        >
          {isLoading ? (
            <>
              <Loader size={20} className="animate-spin" />
              Processing...
            </>
          ) : (
            <>
              <MessageCircle size={22} />
              Contact via WhatsApp
            </>
          )}
        </button>

        <p className="text-center text-sm text-gray-500 mt-2">
          You'll be redirected to our WhatsApp support team
        </p>
      </div>
    </div>
  );
};

export default PuccCertificate;

// import { useEffect } from "react";
// import { toast } from "react-toastify";

// const PuccCertificate = () => {
//   useEffect(() => {
//     const handleRedirect = async () => {
//       // Show loading toast
//       const toastId = toast.loading(
//         "🔄 Redirecting you to WhatsApp. Please wait...",
//         {
//           position: "top-right",
//           autoClose: false,
//         },
//       );

//       // Wait for 2 seconds
//       await new Promise((resolve) => setTimeout(resolve, 2000));

//       // Dismiss loading toast
//       toast.dismiss(toastId);

//       // Show success toast
//       toast.success("Opening WhatsApp...", {
//         position: "top-right",
//         autoClose: 2000,
//       });

//       // WhatsApp number
//       const whatsappPhone = "+919124578108";
//       const whatsappUrl = `https://wa.me/${whatsappPhone.replace(/\D/g, "")}?text=Hello,%20I%20need%20PUCC%20Certificate%20assistance.`;

//       // Open WhatsApp
//       setTimeout(() => {
//         window.open(whatsappUrl, "_blank");
//       }, 500);
//     };

//     handleRedirect();
//   }, []);

//   return null;
// };

// export default PuccCertificate;
